export default {

    init() {

        const DATA_PAYMENT_ID = "payment-id";

        const TABLE_COSTI = "#table-costi";
        const TABLE_COSTI_BODY = "#table-costi tbody";

        const TABLE_ACQUISTI = "#table-acquisti";
        const TABLE_ACQUISTI_BODY = "#table-acquisti tbody";

        const TABLE_CANALI_DI_ACQUISTO = "#table-canali-di-acquisto";
        const TABLE_CANALI_DI_ACQUISTO_BODY = "#table-canali-di-acquisto tbody";

        const BTN_MARK_AS_PAID = ".btn-mark-as-paid";

        const COSTI = "costi";
        const ACQUISTI = "acquisti";
        const CANALI_DI_ACQUISTO = "canali-di-acquisto";

        const INPUT_FILTER_PAID = "#input-filter-paid";
        const INPUT_FILTER_DATE_FROM = "#input-filter-date-from";
        const INPUT_FILTER_DATE_TO = "#input-filter-date-to";

        const TH_COSTI_AMOUNT = "#th-costi-amount";
        const TH_ACQUISTI_AMOUNT = "#th-acquisti-amount";
        const TH_CANALI_DI_ACQUISTO_AMOUNT = "#th-canali-di-acquisto-amount";

        function getFilterFormData() {

            return {
                paid: $(INPUT_FILTER_PAID).val(),
                date_from: $(INPUT_FILTER_DATE_FROM).val(),
                date_to: $(INPUT_FILTER_DATE_TO).val(),
            }
        }

        function accountingLoaded(accounting) {

            $(TH_COSTI_AMOUNT).text(numeral(accounting['importo_costi_totale']).format('0,0.00'));
            $(TH_ACQUISTI_AMOUNT).text(numeral(accounting['importo_acquisti_totale']).format('0,0.00'));
            $(TH_CANALI_DI_ACQUISTO_AMOUNT).text(numeral(accounting['importo_canali_di_acquisto_totale']).format('0,0.00'));
        }

        function loadAccounting() {

            const params = getFilterFormData();
            params['wants_html'] = 0;

            httpRequest.get(`admin/content/api/accounting/debits/accounting`, {
                params: params
            }).then(response => accountingLoaded(response.data.data))
                .catch(error => {
                });
        }

        function updatePaymentRow(payment_id, type) {

            let item = null;

            switch (type) {
                case COSTI:
                    item = $(TABLE_COSTI_BODY).find(`tr[data-payment-id=${payment_id}]`);
                    break
                case ACQUISTI:
                    item = $(TABLE_ACQUISTI_BODY).find(`tr[data-payment-id=${payment_id}]`);
                    break
                case CANALI_DI_ACQUISTO:
                    item = $(TABLE_CANALI_DI_ACQUISTO_BODY).find(`tr[data-payment-id=${payment_id}]`);
                    break
            }

            if (item && item.length) {
                item.addClass('table-success');
                item.find('.td-paid-check').append(`<i class="font-size-18 bx bx-check"></i>`);
                item.find(BTN_MARK_AS_PAID).addClass('d-none');
            }
        }

        function paymentMarkedAsPaid(payment, callback) {

            loadAccounting();

            if (callback && typeof callback === "function") {
                callback();
            }
        }

        function markPaymentAsPaid(payment_id, callback) {

            httpRequest.put(`admin/content/api/payments/${payment_id}/mark-as-paid`)
                .then(response => paymentMarkedAsPaid(response.data.data, callback))
                .catch(error => {

                });
        }

        $(TABLE_COSTI_BODY).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            markPaymentAsPaid(payment_id, function () {
                updatePaymentRow(payment_id, COSTI);
            });
        });

        $(TABLE_ACQUISTI_BODY).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            markPaymentAsPaid(payment_id, function () {
                updatePaymentRow(payment_id, ACQUISTI);
            });
        });

        $(TABLE_CANALI_DI_ACQUISTO_BODY).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            markPaymentAsPaid(payment_id, function () {
                updatePaymentRow(payment_id, CANALI_DI_ACQUISTO);
            });
        });

        loadAccounting();
    },

    finalize() {

    },
}
